(() => {
  const initHorizontalScroll = (scroller) => {
    if (!scroller || scroller.dataset.horizontalScrollReady === 'true') return;
    scroller.dataset.horizontalScrollReady = 'true';

    const root = scroller.closest('[data-horizontal-scroll-root]') || scroller.parentElement;
    const prevBtn = root?.querySelector('[data-horizontal-scroll-prev]');
    const nextBtn = root?.querySelector('[data-horizontal-scroll-next]');

    const updateArrows = () => {
      if (!prevBtn || !nextBtn) return;

      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const hasOverflow = maxScroll > 2;

      root.classList.toggle('has-hscroll', hasOverflow);

      if (!hasOverflow) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      const atStart = scroller.scrollLeft <= 2;
      const atEnd = scroller.scrollLeft >= maxScroll - 2;

      prevBtn.hidden = false;
      nextBtn.hidden = false;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    };

    const scrollByPage = (direction) => {
      const amount = Math.max(scroller.clientWidth * 0.7, 160);
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    prevBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      scrollByPage(-1);
    });

    nextBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      scrollByPage(1);
    });

    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let dragging = false;
    let moved = false;

    const onWheel = (event) => {
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

      event.preventDefault();
      scroller.scrollLeft += event.deltaY;
    };

    const onPointerDown = (event) => {
      if (event.pointerType === 'touch') return;
      if (event.button !== 0) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = scroller.scrollLeft;
      dragging = true;
      moved = false;
      scroller.classList.add('is-dragging');
    };

    const onPointerMove = (event) => {
      if (!dragging || event.pointerId !== pointerId) return;

      const delta = event.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      scroller.scrollLeft = startScroll - delta;
    };

    const onPointerUp = (event) => {
      if (event.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
      scroller.classList.remove('is-dragging');
    };

    const onClickCapture = (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    };

    scroller.addEventListener('wheel', onWheel, { passive: false });
    scroller.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);
    scroller.addEventListener('click', onClickCapture, true);
    scroller.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(scroller);
      if (scroller.firstElementChild) {
        new ResizeObserver(updateArrows).observe(scroller.firstElementChild);
      }
    }

    requestAnimationFrame(updateArrows);
    if (document.fonts?.ready) {
      document.fonts.ready.then(updateArrows);
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-horizontal-scroll]').forEach(initHorizontalScroll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
